import React, { useState } from 'react';
import { Button, Select } from 'antd';
import { MobileDataYearly } from '../MobileDataYearly';
import { MobileDataMonthly } from '../MobileDataMonthly';
import { MobileDataDaily } from '../MobileDataDaily';

import './MobileData.scss';
import moment from 'moment';
import { DownOutlined } from '@ant-design/icons';

/**
 * @param {object} props
 * @param {boolean} props.disabled
 * @param {string} props.periodic
 * @param {(value: {
 *  periodic?: string,
 *  year?: number,
 *  month?: number,
 *  day?: number
 * }) => void} props.onChange
 * @param {number} props.year
 * @param {number} props.month
 * @param {number} props.day
 * @param {number[]} props.providedYear
 * @param {boolean} props.isDatex
 */
export const MobileData = (props) => {
  const now = moment();
  const [isOpenCalender, setIsOpenCalender] = useState(false);

  const mappingCallbackValue = (periodic) => {
    switch (periodic) {
      case 'daily': {
        const date = now.clone().subtract(8, 'days'); // gunakan clone agar tidak merusak state `now`
        return {
          periodic: 'daily',
          year: date.year(),
          month: date.month() + 1,
          day: date.get('D')
        };
      }
      case 'monthly': {
        return {
          periodic: 'monthly',
          year: now.year(),
          month: now.month() + 1,
          day: 0
        };
      }
      case 'yearly': {
        return {
          periodic: 'yearly',
          year: now.year() - 1,
          month: 0,
          day: 0,
        };
      }
      default: {
        return {
          periodic: '',
          year: 0,
          month: 0,
          day: 0,
        };
      }
    }
  };

  const onChangePeriodic = (value) => {
    setIsOpenCalender(false);
    const periodic = value || '';

    props?.onChange?.( {
      periodic: periodic,
      year: 0,
      month: 0,
      day: 0,
    });
  };

  const getPlaceHolder = (periodic) => {
    if (periodic === 'yearly') {
      return 'Select Year';
    } else if (periodic === 'monthly') {
      return 'Select Month';
    } else {
      return 'Select Date';
    }
  };

  const getDisplayValue = (props) => {
    const { day, month, year, periodic } = props;

    if (day || month || year) {
      const dayStr = day ? day.toString().padStart(2, '0') + '/' : '';
      const monthStr = month ? month.toString().padStart(2, '0') + '/' : '';
      const yearStr = year || '';

      return `${dayStr}${monthStr}${yearStr}`;
    }

    return getPlaceHolder(periodic);
  };


  return (
    <div className='feature-genset-MD MobileData'>
      <Select
        className='select-time'
        disabled={props.disabled}
        onChange={onChangePeriodic}
        placeholder='Select Timeframe'
        style={{ width: '100%' }}
        value={props?.periodic}
      >
        {!props.isDatex && <Select.Option value=''>None</Select.Option>}
        <Select.Option value='daily'>Hourly</Select.Option>
        <Select.Option value='monthly'>Daily</Select.Option>
        <Select.Option value='yearly'>Monthly</Select.Option>
      </Select>

      <div className={`date-picker-trigger${isOpenCalender ? ' active' : ''}`}>
        <Button
          disabled={!props?.periodic}
          icon={<DownOutlined />}
          onClick={() => {
            const newValue = mappingCallbackValue(props?.periodic);
            !props.day && !props.month && !props.year && props?.onChange?.(newValue);
            setIsOpenCalender(!isOpenCalender);
          }}
          style={{ width: '100%', textAlign: 'left' }}
        >
          {getDisplayValue(props)}
        </Button>
        {isOpenCalender && (
          <div className='wrapper-absolute'>
            <div className='card-calender'>
              {props?.periodic === 'daily' && (
                <MobileDataDaily
                  onChange={(e) => {
                    props?.onChange?.({ periodic: 'daily', ...e });
                    !e.auto && setIsOpenCalender(false);
                  }}
                  providedYear={props?.providedYear}
                  value={{
                    year: props?.year,
                    month: props?.month,
                    day: props?.day,
                  }}
                />
              )}
              {props?.periodic === 'monthly' && (
                <MobileDataMonthly
                  onChange={(e) => {
                    props?.onChange?.({ periodic: 'monthly', ...e });
                    !e.auto && setIsOpenCalender(false);
                  }}
                  providedYear={props?.providedYear}
                  value={{
                    year: props?.year,
                    month: props?.month,
                  }}
                />
              )}
              {props?.periodic === 'yearly' && (
                <MobileDataYearly
                  onChange={(e) => {
                    props?.onChange?.({ periodic: 'yearly', ...e });
                    !e.auto && setIsOpenCalender(false);
                  }}
                  providedYear={props?.providedYear}
                  value={props?.year}
                />
              )}
            </div>
          </div>
        )}
      </div>


    </div>
  );
};
